import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiPaths } from "../../../../service/apiPaths";
import ApiService from "../../../../service/ApiService";
import { IAddTestQuestion } from "../../TestQuestion.props";
import { SubmitHandler } from "react-hook-form";
import toast from "react-hot-toast";

interface FormData1 {
  [key: string]: string | number | any;
}

const useEditTestQuestion = (questionId: string,setSelectedTestQuestionId: React.Dispatch<React.SetStateAction<string | any>>) => {
  const [formData, setFormData] = useState<FormData1>({
    questionText: "",
    description: "",
    level: "",
    subject: "",
    standard: "",
    courseName: "",
    languageName: "",
    options: [
      { optionText: "", isCorrect: false },
      { optionText: "", isCorrect: false },
      { optionText: "", isCorrect: false },
      { optionText: "", isCorrect: false },
    ],
    isLiveMcq: false,
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [courses, setCourses] = useState<any[]>([]);
  const [languages, setLanguages] = useState<any[]>([]);
  const [subjectName, setSubjectName] = useState<any[]>([]);
  const [standard, setStandard] = useState<any[]>([]);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await ApiService({
        method: "GET",
        endpoint: `${apiPaths.question}/${questionId}`,
      });
      console.log(response)
        setFormData(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load test series data.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLSelectElement | HTMLInputElement | HTMLTextAreaElement | any>,
    fieldPath: string
  ): void => {
    const { value, type, checked } = e.target;

    try {
      // Handle options array
   // Handle options array
if (fieldPath.startsWith('options[')) {
  const matches = fieldPath.match(/options\[(\d+)\]\.(\w+)/);

  if (matches) {
    const [_, indexStr, property] = matches;
    const index = parseInt(indexStr, 10);

    setFormData(prevData => {
      const newOptions = prevData.options.map((option: any, i: any) => {
        if (i === index) {
          return {
            ...option,
            [property]: property === 'isCorrect' ? true : value
          };
        } else {
          if (property === 'isCorrect') {
            return {
              ...option,
              [property]: false
            };
          }
        }
        return option; // This return is missing for non-matching options when property !== 'isCorrect'
      });

      return {
        ...prevData,
        options: newOptions
      };
    });
  }
}

      // Handle regular fields
      setFormData(prevData => ({
        ...prevData,
        [fieldPath]: type === "checkbox" ? checked : value
      }));
      console.log("FORMDATA CHANGED FOR QUESTIONS 2: ", formData);

    } catch (error) {
      console.error('Error updating form data:', error);
    }
  };

  const fetchCoursesAndLanguages = async () => {
    try {
      setLoading(true);
      const [
        coursesResponse,
        languagesResponse,
        subjectResponse,
        standardResponse,
      ] = await Promise.all([
        ApiService({ method: "GET", endpoint: apiPaths.getCourse }),
        ApiService({ method: "GET", endpoint: apiPaths.getlanguage }),
        ApiService({ method: "GET", endpoint: apiPaths.getSubject }),
        ApiService({ method: "GET", endpoint: apiPaths.getStandard }),
      ]);

      setCourses(coursesResponse);
      setLanguages(languagesResponse);
      setSubjectName(subjectResponse);
      setStandard(standardResponse);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit: SubmitHandler<IAddTestQuestion> = async () => {
    console.log("FORMDATA CHANGED FOR QUESTIONS MAIN : ", formData);
    setLoading(true);
    try {
      await ApiService({
        method: "PUT",
        endpoint: `${apiPaths.question}/${questionId}`,
        data: formData,
      });
      toast.success("Question updated successfully");
      setSelectedTestQuestionId(null)
    } catch (error) {
      toast.error("Error updating Question", {
        duration: 10000,
      });
      console.error("Error updating Questions:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (questionId) {
      fetchData();
      fetchCoursesAndLanguages();
    }
  }, [questionId]);

  const handleCancel = () => {
    setSelectedTestQuestionId(null)
  };

  return {
    loading,
    formData,
    courses,
    languages,
    subjectName,
    standard,
    handleChange,
    handleSubmit,
    handleCancel,
  };
};

export default useEditTestQuestion;
